import React, { useState, useEffect } from "react";
import { Button } from "../button/Button";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";

import { useUserContext } from "../../contexts/UserContext";

const MOBILE_NAV_BREAKPOINT = 1200;

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const { logout, isAuthenticated, isAdmin } = useUserContext();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= MOBILE_NAV_BREAKPOINT) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
    window.addEventListener("resize", showButton);
    return () => {
      window.removeEventListener("resize", showButton);
    };
  }, []);

  const AuthLinks = () => (
    <>
      {!isAdmin ? (
        <>
          <li className="nav-item">
            <Link
              to="/neworder"
              className="nav-links order"
              onClick={closeMobileMenu}
            >
              Create Order
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/orders"
              className="nav-links order"
              onClick={closeMobileMenu}
            >
              Order History
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/profile"
              className="nav-links order"
              onClick={closeMobileMenu}
            >
              Profile
            </Link>
          </li>
        </>
      ) : null}
      <li className="nav-item">
        <Link
          to="/"
          className="nav-links"
          onClick={() => {
            closeMobileMenu();
            logout();
          }}
        >
          <span className="hide-sm">Logout</span>
        </Link>
      </li>
    </>
  );

  const GuestLinks = () => (
    <>
      <li className="nav-item">
        <Link className="nav-links login" to="/login" onClick={closeMobileMenu}>
          Login
        </Link>
      </li>

      <li className="nav-btn">
        {button ? (
          <Link to="/register" className="nav-links" onClick={closeMobileMenu}>
            <Button buttonStyle="btn--outline">SIGN UP</Button>
          </Link>
        ) : (
          <Link to="/register" className="nav-links" onClick={closeMobileMenu}>
            <Button
              buttonStyle="btn--outline"
              buttonSize="btn--mobile"
              onClick={closeMobileMenu}
            >
              SIGN UP
            </Button>
          </Link>
        )}
      </li>
    </>
  );

  // Keep the admin navigation grouped around operational workflows; compliance is part of that toolset.
  const AdminLinks = () => (
    <>
      <li className="nav-item">
        <Link
          className="nav-links"
          to="/admin/orders"
          onClick={closeMobileMenu}
        >
          Edit Orders
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-links"
          to="/admin/deliveries"
          onClick={closeMobileMenu}
        >
          Edit Deliveries
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-links"
          to="/admin/customers"
          onClick={closeMobileMenu}
        >
          Customers
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-links"
          to="/admin/compliance"
          onClick={closeMobileMenu}
        >
          Compliance
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-links"
          to="/admin/settings"
          onClick={closeMobileMenu}
        >
          Settings
        </Link>
      </li>
    </>
  );

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img
              src="/images/lunde-water-logo.png"
              alt="Lunde Water, LLC"
              className="navbar-icon"
              style={{ height: 34 }}
            />
            LUNDE WATER, LLC
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            {click ? <FaTimes /> : <FaBars />}
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/" className="nav-links home" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about-us"
                className="nav-links home"
                onClick={closeMobileMenu}
              >
                About
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/water-quality"
                className="nav-links home"
                onClick={closeMobileMenu}
              >
                Our Water
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/privacy"
                className="nav-links home"
                onClick={closeMobileMenu}
              >
                Privacy
              </Link>
            </li>
            {!isAuthenticated && (
              <li className="nav-item">
                <Link
                  to="/customercalculator"
                  className="nav-links home"
                  onClick={closeMobileMenu}
                >
                  Get an Estimate
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-links home"
                onClick={closeMobileMenu}
              >
                Contact Us
              </Link>
            </li>
            {isAdmin && <AdminLinks />}
            {isAuthenticated ? <AuthLinks /> : <GuestLinks />}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
